import { render } from "./CreateForm.vue?vue&type=template&id=0c5a69dd&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"

import "./CreateForm.vue?vue&type=style&index=0&id=0c5a69dd&scoped=true&lang=css"
import "./CreateForm.vue?vue&type=style&index=1&id=0c5a69dd&lang=css"
import "./CreateForm.vue?vue&type=style&index=2&id=0c5a69dd&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5a69dd"]])

export default __exports__